export const URL = 'https://yj-forever.com';

export const VENUE = {
  name: '제주 퍼시픽 호텔',
  address: '제주시 서사로 20',
};

export const SCHEDULE = {
  datetime: '2025/6/1',
  date: '2025년 6월 1일',
  day: '일요일',
  time: '오전 11시',
};

export const GROOM = {
  name: '홍영준',
  nameEng: 'YOUNGJUN',
  phone: '010-1234-1234',
  account: ['제주은행', '1234567891011'],
  child: '아들',
  parents: {
    father: {
      name: '홍지석',
      phone: '010-1234-1234',
      account: ['우체국', '510016-02-053376'],
    },
    mother: {
      name: '한재후',
      phone: '010-1234-1234',
      account: ['농협', '901016-52-157391'],
    },
  },
};

export const BRIDE = {
  name: '오유진',
  nameEng: 'YUJIN',
  phone: '010-7259-6759',
  account: ['제주은행', '1234567891011'],
  child: '딸',
  parents: {
    father: {
      name: '오중근',
      phone: '010-1234-1234',
      account: ['제주은행', '1234567891011'],
    },
    mother: {
      name: '원양숙',
      phone: '010-1234-1234',
      account: ['제주은행', '1234567891011'],
    },
  },
};

export const ACCOUNTS = [
  {
    id: 1,
    name: '신랑측',
    accounts: [
      {
        id: 1,
        name: '홍영준',
        role: '신랑',
        account: ['농협', '356-0504-8941-83'],
      },
      {
        id: 2,
        name: '홍지석',
        role: '아버지',
        account: ['우체국', '510016-02-053376'],
      },
      {
        id: 3,
        name: '한재후',
        role: '어머니',
        account: ['농협', '901016-52-157391'],
      },
    ],
  },
  {
    id: 2,
    name: '신부측',
    accounts: [
      {
        id: 1,
        name: '오유진',
        role: '신부',
        account: ['농협', '356-1606-6651-83'],
      },
      {
        id: 2,
        name: '오중근',
        role: '아버지',
        account: ['농협', '356-0454-8741-33'],
      },
      {
        id: 3,
        name: '원양숙',
        role: '어머니',
        account: ['농협', '901099-52-089978'],
      },
    ],
  },
];

export const INFO_MENU = [
  { id: 'greeting', name: '모시는 글' },
  { id: 'date', name: '일정' },
  { id: 'venue', name: '오시는 길' },
  { id: 'account', name: '마음 전하실 곳' },
];

export const MAP_LIST = [
  { id: 1, name: '네이버 지도', link: 'https://naver.me/G4WCRsI1' },
  { id: 2, name: '카카오맵', link: 'https://kko.kakao.com/e4zCNoL-5s' },
  { id: 3, name: '구글맵', link: 'https://maps.app.goo.gl/rZksSAwponUdg3p47' },
];
